<div class="helper">
  <img src="assets/images/helper-icon.png" alt="" />
  <app-tooltip>
    <div class="esia-err-message">
      <ng-content></ng-content>
    </div>
  </app-tooltip>
</div>
